import { usePlatform } from '@/platform/usePlatform';
import { plural } from '@/utils/plural';

import { usePacks } from './usePacks';
import { usePurchase } from './usePurchase';

/**
 * Пакеты кредитов. Ни цен, ни размеров здесь нет — всё из базы. На площадке,
 * где оплаты ещё нет, раздел не прячется молча, а говорит, где пополнить:
 * кредиты видны везде, а купить их можно там, где оплата подключена.
 */
export function PacksSection() {
  const platform = usePlatform();
  const packs = usePacks();
  const { buy, status, message } = usePurchase();

  if (platform.paymentKind === null) {
    return (
      <section className="flex flex-col gap-2">
        <h2 className="text-lg font-semibold text-text">Пополнить кредиты</h2>
        <p className="text-sm text-text-2">Пополнение сейчас доступно в Студии в Telegram. Купленные там кредиты видны и здесь.</p>
      </section>
    );
  }

  const busy = status === 'opening';

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-lg font-semibold text-text">Пополнить кредиты</h2>

      {packs.isPending && <p className="text-text-2">Загружаем пакеты…</p>}

      {packs.isError && (
        <div>
          <p className="text-danger">Не удалось загрузить пакеты. Проверьте интернет и попробуйте ещё раз.</p>
          <button type="button" onClick={() => void packs.refetch()} className="mt-2 text-sm text-accent hover:underline">
            Повторить
          </button>
        </div>
      )}

      {packs.data?.length === 0 && <p className="text-sm text-text-2">Пакеты пока не опубликованы. Загляните позже.</p>}

      {packs.data && packs.data.length > 0 && (
        <ul className="flex flex-col gap-3">
          {packs.data.map((pack) => (
            <li key={pack.id} className="flex items-center justify-between gap-3 rounded-card border border-border bg-surface px-4 py-3">
              <div>
                <p className="text-text">
                  {pack.credits} {plural(pack.credits, ['кадр', 'кадра', 'кадров'])}
                </p>
                <p className="text-sm text-text-2">{pack.priceStars} ⭐</p>
              </div>
              <button
                type="button"
                disabled={busy}
                onClick={() => buy(pack.id)}
                className="btn btn-primary px-4 py-3 text-sm"
              >
                Купить
              </button>
            </li>
          ))}
        </ul>
      )}

      {status === 'waiting' && message && (
        <p role="status" className="text-sm text-text-2">
          {message}
        </p>
      )}

      {status === 'error' && message && (
        <p role="alert" className="text-sm text-danger">
          {message}
        </p>
      )}
    </section>
  );
}
